const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Two8: load cart-drawer upsell script (resolves asset URL from this file's own tag) */
(function () {
  try {
    var el = document.querySelector('script[src*="constants.js"]');
    var src = el ? el.getAttribute('src').replace('constants.js', 'two8-cart-upsell.js') : null;
    if (src && !document.querySelector('script[src*="two8-cart-upsell.js"]')) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      (document.head || document.documentElement).appendChild(s);
    }
  } catch (e) {}
})();
